import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AppLayout } from "../layouts/AppLayout";
// Importing components
import { Dashboard } from "../containers/dashboard";
import { Login } from "../containers/auth/login";
import { Logout } from "../containers/auth/logout";
import { Register } from "../containers/auth/register";
import { AuthCallback } from "../containers/auth/callback";
import { Unauthorized } from "../containers/auth/unauthorized";
import { Profile } from "../containers/profile/index";
import { Customers } from "../containers/customers";
import { Users } from "../containers/settings/users";
import { Billing } from "../containers/settings/plan";
import { Subscription } from "../containers/settings/plan/subscription";
import { BillingHistory } from "../containers/settings/plan/billingHistory";
import { SiteSettings } from "../containers/sites";
import { SiteSettingsDetails } from "../containers/sites/details";
import { PatrolRoutes } from "../containers/patrolRoutes";
import { Reporting } from "../containers/reporting";
import { Reports } from "../containers/reporting/reports";
import { Schedules } from "../containers/scheduling/schedules";
import { ShiftTemplates } from "../containers/scheduling/shiftTemplates";
import { Organization } from "../containers/settings/organization";
import { Superadmin } from "../containers/superadmin";
import { SearchResults } from "../containers/search";
import { Messaging } from "../containers/messaging";
import ProtectedRoute from "./ProtectedRoute";

const RoutesWrapper = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/auth/login/" element={<Login />} />
      <Route path="/auth/logout/" element={<Logout />} />
      <Route path="/auth/callback/" element={<AuthCallback />} />
      <Route path="/auth/register/" element={<Register />} />
      <Route path="/auth/unauthorized/" element={<Unauthorized />} />

      {/* Protected Routes */}
      <Route
        path="/profile/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="profile">
              <Profile />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="dashboard">
              <Dashboard />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/messaging"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="messaging">
              <Messaging />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/search"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="search">
              <SearchResults />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/scheduling/schedules/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="schedules">
              <Schedules />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/scheduling/shift-templates/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="shiftTemplates">
              <ShiftTemplates />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reporting/activities"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="activities">
              <Reporting />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reporting/reports/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="reports">
              <Reports />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="customers">
              <Customers />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/sites/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="sites">
              <SiteSettings />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sites/:id"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="sites">
              <SiteSettingsDetails />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/patrol-routes/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="patrol-routes">
              <PatrolRoutes />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/users/"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="users">
              <Users />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/organization/"
        element={
          <ProtectedRoute allowInitialization requiredRole="admin:access">
            <AppLayout current="organization">
              <Organization />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <ProtectedRoute requiredRole="admin:access">
            <AppLayout current="billing">
              <Billing />
            </AppLayout>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="subscription" replace />} />
        <Route path="subscription" element={<Subscription />} />
        <Route path="bill-history" element={<BillingHistory />} />
      </Route>

      <Route
        path="/superadmin/"
        element={
          <ProtectedRoute requireSuperadmin>
            <AppLayout current="superadmin">
              <Superadmin />
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export { RoutesWrapper };
